import { useCallback } from 'react';
import { useSweepApi } from '../sweep';
import {
  SfdcReportAttributes,
  SfdcReportColumnsAttributes,
} from '../../components/Automations/SalesforceReportSelector';
import { Report } from '../../types/Reports';

export const useReportingApiFacade = () => {
  const sweepApi = useSweepApi();

  return {
    get_reports: useCallback(async () => {
      const response = await sweepApi.get(`/reporting`);
      return response.data as Report[];
    }, [sweepApi]),

    get_isAllowedToActivateReporting: useCallback(async () => {
      const response = await sweepApi.get(`/reporting/activate/is-allowed`);
      return response.data as boolean;
    }, [sweepApi]),

    patch_activateReport: useCallback(
      async (report: Pick<Report, 'id' & 'status'>) => {
        const response = await sweepApi.patch(`/reporting/activate`, report);
        return response.data as Report;
      },
      [sweepApi],
    ),

    post_deactivateReport: useCallback(
      async (reportId: string) => {
        const response = await sweepApi.post(`/reporting/${reportId}/deactivate`);
        return response.data as Report;
      },
      [sweepApi],
    ),

    get_tabularReports: useCallback(async () => {
      const response = await sweepApi.get(`/reporting/reports/tabular`);
      return response.data as SfdcReportAttributes[];
    }, [sweepApi]),

    get_reportColumnsIds: useCallback(
      async (reportId: string) => {
        const response = await sweepApi.get(`/reporting/reports/${reportId}/columns`);
        return response.data as SfdcReportColumnsAttributes[];
      },
      [sweepApi],
    ),
  };
};
